module.exports = __webpack_public_path__ + "img/icon-car-active.df8c5600.svg";